import React from 'react';

import { HotelDetailAnnouncementViewModel } from '@api/models/HotelDetailAnnouncementViewModel';
import Markdown from '@components/utils/Markdown';
import { Separator } from '@components/formStyles';

import {
  Container,
  Title,
  Wrapper,
  TitleAnnouncement,
} from './AnnouncementsStyle';

interface AnnouncementsProps {
  data?: Array<HotelDetailAnnouncementViewModel>;
}

const Announcements = ({ data }: AnnouncementsProps) => (
  <Container>
    <Title>Otel Duyuruları</Title>
    <Separator />
    {data?.map((item, index) => (
      <Wrapper key={index}>
        <TitleAnnouncement>
          <Markdown text={item.title} />
        </TitleAnnouncement>
        <Markdown text={item.description} />
      </Wrapper>
    ))}
  </Container>
);

export default Announcements;
